import React from 'react'
import classes from '@src/styles/disposal/sustainabilityDashboardPromo.module.css'

function SustainabilityDashboardPromo() {
  return (
    <div className={classes.root}>
      <img
        className={classes.img}
        alt="Sustainability Dashboard Screenshot"
        src="/sustainability-dashboard.svg"
      />
    </div>
  )
}

export default SustainabilityDashboardPromo
